'use strict';

export default  {
    SMALL_BREAKPOINT: '39.9375em'
};
